import { Link } from 'react-router-dom';
import { Leaf, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              {/* ✅ Logo with image */}
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <img
              src="/logo1.png"         
              alt="Solar Vision Tech"
              className="h-12 w-auto object-contain group-hover:scale-105 transition-transform"
            />
          </Link>
            </div>
            <p className="text-primary-foreground/80 leading-relaxed">
              Leading the renewable energy revolution with sustainable solar solutions.
            </p>
            <div className="flex gap-4 pt-4">
              <a href="#" className="hover:text-secondary transition-colors" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://x.com/solarvisiontech" className="hover:text-secondary transition-colors" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/solarvisiontech/" className="hover:text-secondary transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              {/* <a href="#" className="hover:text-secondary transition-colors" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="hover:text-secondary transition-colors" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/services" className="hover:text-secondary transition-colors" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/projects" className="hover:text-secondary transition-colors" data-testid="footer-link-projects">Projects</Link></li>
              <li><Link to="/about" className="hover:text-secondary transition-colors" data-testid="footer-link-about">About</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-3">
              <li><span className="text-primary-foreground/80">Residential Solar</span></li>
              <li><span className="text-primary-foreground/80">Commercial Solar</span></li>
              <li><span className="text-primary-foreground/80">Maintenance & Repair</span></li>
              <li><span className="text-primary-foreground/80">Solar Consulting</span></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-secondary mt-0.5 flex-shrink-0" />
                <span className="text-primary-foreground/80">9, Sadbhavna Nagar, Zingabai Takli, Nagpur, Maharashtra, India</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-secondary flex-shrink-0" />
                <a href="tel:+917588799488" className="text-primary-foreground/80 hover:text-secondary transition-colors">+91 7588799488</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-secondary flex-shrink-0" />
                <a href="mailto:info@solarvisiontech.in" className="text-primary-foreground/80 hover:text-secondary transition-colors">info@solarvisiontech.in</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-12 pt-8 text-center text-primary-foreground/60">
          <p>&copy; {new Date().getFullYear()} Solar Vision Tech. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};